import { TTypeOfCodec } from "../../../shared/src/codecs/codec";
import { array } from "../../../shared/src/codecs/types/array";
import { boolean } from "../../../shared/src/codecs/types/boolean";
import { dateTime } from "../../../shared/src/codecs/types/dateTime";
import { form, TFormCodec } from "../../../shared/src/codecs/types/form";
import { nullCodec } from "../../../shared/src/codecs/types/nullCodec";
import { partial } from "../../../shared/src/codecs/types/partial";
import { required, TRequiredCodec } from "../../../shared/src/codecs/types/required";
import { string } from "../../../shared/src/codecs/types/string";
import { union } from "../../../shared/src/codecs/types/union";
import { TUuidCodec, uuid } from "../../../shared/src/codecs/types/uuid";
import { EmptyObject, TEmptyObjectCodec } from "../EmptyObject";

export const IntroducerApiTokenView = required({
    jti: uuid(),
    label: string(),
    created_at: dateTime(),
    last_used_at: union([nullCodec(), dateTime()]),
    capabilities: array(string()),
    is_test_mode: boolean(),
});
export type TIntroducerApiTokenViewCodec = typeof IntroducerApiTokenView;
export type TIntroducerApiTokenView = TTypeOfCodec<TIntroducerApiTokenViewCodec>;

export const CreateIntroducerApiTokenForm = form(
    required({
        introducer_id: uuid(),
        label: string(),
        capabilities: array(string()),
        is_test_mode: boolean(),
    }),
    partial({
        returned_token: string(),
    }),
);
export type TCreateIntroducerApiTokenFormCodec = typeof CreateIntroducerApiTokenForm;
export type TCreateIntroducerApiTokenForm = TTypeOfCodec<TCreateIntroducerApiTokenFormCodec>;

export const RevokeIntroducerApiTokenForm: TFormCodec<
    TRequiredCodec<{
        jti: TUuidCodec,
    }>,
    TEmptyObjectCodec
> = form(
    required({
        jti: uuid(),
    }),
    EmptyObject,
);
export type TRevokeIntroducerApiTokenFormCodec = typeof RevokeIntroducerApiTokenForm;
export type TRevokeIntroducerApiTokenForm = TTypeOfCodec<TRevokeIntroducerApiTokenFormCodec>;
